import { EntityTypes } from '../../../new-lib/constants/common';

export const getCompareListIds = (state: any, compareType: string) => {
  if (compareType === 'compounds' || compareType === EntityTypes.COMPOUND) {
    return state.compare.compounds_ids;
  }
  return state.compare.properties_ids;
};
